"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tom_select_1 = __importDefault(require("tom-select"));
window.TomSelect = tom_select_1.default;
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll("select.select3")
        .forEach(function (select) {
        if (!select.dataset.tomSelectApplied) {
            var ts = new tom_select_1.default(select, {
                create: false,
                sortField: [{ field: "text", direction: "asc" }],
                placeholder: select.getAttribute("placeholder") || "",
                plugins: ["dropdown_input"],
                onDropdownOpen: function () {
                    var self = this;
                    var dropdown = self.dropdown;
                    if (!dropdown)
                        return;
                    var rect = self.control.getBoundingClientRect();
                    var dropdownHeight = dropdown.offsetHeight || 200;
                    if (window.innerHeight - rect.bottom < dropdownHeight &&
                        rect.top > dropdownHeight) {
                        dropdown.classList.add("dropup");
                    }
                    else {
                        dropdown.classList.remove("dropup");
                    }
                },
                onDropdownClose: function () {
                    var _a;
                    var self = this;
                    (_a = self.dropdown) === null || _a === void 0 ? void 0 : _a.classList.remove("dropup");
                },
            });
            select.dataset.tomSelectApplied = "true";
        }
    });
});
